module.exports = __webpack_public_path__ + "static/img/IMAS.348bef81.jpg";